export {
  TemplateDocListProperty,
  TemplateFilterValue,
  TemplateGroupHeader,
} from '../workspace-property-types/template';
